"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { loggerLink, unstable_httpBatchStreamLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import { useState } from "react";

import { type AppRouter } from "~/server/api/root";
import { getUrl, transformer } from "./shared";
import { useSetRecoilState } from "recoil";
import {
  refreshBalanceCountAtom,
  refreshSessionCountAtom,
} from "~/state/atoms";
import { useSession } from "next-auth/react";
import { message } from "antd";

export const api = createTRPCReact<AppRouter>();

export function TRPCReactProvider(props: {
  children: React.ReactNode;
  cookies: string;
}) {
  const { update } = useSession();
  const setRefreshBalanceCount = useSetRecoilState(refreshBalanceCountAtom);
  const setRefreshSessionCount = useSetRecoilState(refreshSessionCountAtom);

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            onSuccess: (data) => {
              //
            },
          },
          mutations: {
            onSettled(data, error, variables: any, context) {
              if (
                data === "DAILY_MAX_POINT_EXCEEDED" &&
                (localStorage.getItem("dailyPointExceeded") !==
                  new Date().toDateString() ||
                  !localStorage.getItem("dailyPointExceeded"))
              ) {
                void message.error(
                  "You have reached the daily limit of 500 FAO for receipt",
                );
                localStorage.setItem(
                  "dailyPointExceeded",
                  new Date().toDateString(),
                );
              }
              setRefreshBalanceCount((prev) => prev + 1);
              setRefreshSessionCount((prev) => prev + 1);
              void update();
            },
          },
        },
      }),
  );

  const [trpcClient] = useState(() =>
    api.createClient({
      transformer,
      links: [
        loggerLink({
          enabled: (op) =>
            process.env.NODE_ENV === "development" ||
            (op.direction === "down" && op.result instanceof Error),
        }),
        unstable_httpBatchStreamLink({
          url: getUrl(),
          headers() {
            return {
              cookie: props.cookies,
              "x-trpc-source": "react",
            };
          },
        }),
      ],
    }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <api.Provider client={trpcClient} queryClient={queryClient}>
        {props.children}
      </api.Provider>
    </QueryClientProvider>
  );
}
